export default import.meta.ROLLUP_FILE_URL_hO4dd8ILk$iZF7aFIOUkdg;